export enum NCSGridHeader {
    PartnerCenter = 1,
    NetChainsStartedUsable = 2,
    UnredeemedFVDonations = 3,
    NetChainStartedScore = 4,
    CenterAcceptsAnyAnatomy = 5,
    WaitListDeclineRatio = 6,
    FVDonations = 7,
    SVDonations = 8,
    CompatiblePairTxps = 9,
    CompatibleRemoteSVOrPaired = 10,
    FavorAboCompatibleOrPaired = 11,
    AnyAnatomyAndZeroDecline = 12,
    CompositeScore = 13,
    CompositeScorePercent = 14,
    ShareOfFloat = 15,
    DonorAcceptanceBonus = 16,
    TargetedChainEnds = 17
}

type HeaderContent = {
  title: string;
  description: string;
};

export const GridHeaderMap: Record<NCSGridHeader, HeaderContent> = {
  [NCSGridHeader.PartnerCenter]: {
    title: "Partner Center",
    description:
      "Equal Access Member Centers designated to absorb the chain end kidneys resulting from the Voucher Program and to facilitate living donor kidney transplants for voucher patients if / when they return for transplants.",
  },

  [NCSGridHeader.NetChainsStartedUsable]: {
    title: "Net Chains Started Usable",
    description:
      "(# of NDDs scheduled and donated) - (# of Waitlist/KRC/Broken chain patients scheduled and transplanted)",
  },

  [NCSGridHeader.UnredeemedFVDonations]: {
    title: "Unredeemed Family Voucher Donations",
    description:
      "(# of FVDs donated) - (# of Redeemed FVHs)",
  },

  [NCSGridHeader.NetChainStartedScore]: {
    title: "Net Chains Started Score",
    description:
      "NCS Usable + Unredeemed Family Voucher Donations",
  },

  [NCSGridHeader.CenterAcceptsAnyAnatomy]: {
    title: "Center Accepts Any Functional Anatomy",
    description:
      "Based on the center's Functional Waitlist Anat.",
  },

  [NCSGridHeader.WaitListDeclineRatio]: {
    title: "Waitlist Decline Ratio",
    description:
      "Waitlists offer decline in the last 6 months / Waitlist offers in the last 6 months",
  },

  [NCSGridHeader.FVDonations]: {
    title: "Family Voucher Donations Last 24 Months",
    description:
      "Family Voucher Donors who donated within the last 24 months.",
  },

  [NCSGridHeader.SVDonations]: {
    title: "Standard Voucher Donations Last 24 Months",
    description:
      "Standard Voucher Donors who donated within the last 24 months.",
  },

  [NCSGridHeader.CompatiblePairTxps]: {
    title: "Compatible Pair Transplants via Paired Exchange Last 24 Months",
    description:
      "Paired patients or voucher holders transplanted in the last 24 months who were ABO and HLA compatible with their intended donor.",
  },

  [NCSGridHeader.CompatibleRemoteSVOrPaired]: {
    title: "Compatible Remote Standard Voucher or Paired Donations Last 24 Months",
    description:
      "Remote standard voucher or paired donors who were ABO and HLA compatible with their intended recipient and donated within the last 24 months.",
  },

  [NCSGridHeader.FavorAboCompatibleOrPaired]: {
    title: "Favorable ABO Compatible Pair Transplants via Paired Exchange Last 24 Months",
    description:
      "Paired patients or voucher holders transplanted in the past 24 months whose intended donor was blood type O, recipient blood type was A, B, or AB, and who were ABO and HLA compatible.",
  },

  [NCSGridHeader.AnyAnatomyAndZeroDecline]: {
    title: "Any Functional Anatomy + Zero Decline Bonus",
    description:
      "20% Composite Score bonus for accepting any functional anatomy for chain-end offers and maintaining a Waitlist Decline Ratio of 0 for the past 6 months.",
  },

  [NCSGridHeader.CompositeScore]: {
    title: "Composite Score",
    description:
      "Sum of (FVDs + SVDs + Compatible pair transplants) last 24 months + Any Functional Anatomy & Zero Decline Bonus",
  },

  [NCSGridHeader.CompositeScorePercent]: {
    title: "Composite Score %",
    description:
      "Composite Score / Sum of all Composite Scores",
  },

  [NCSGridHeader.ShareOfFloat]: {
    title: "Share of Float",
    description:
      "((NCSu + FVCume) × -1 × 1.2) × Composite Score %",
  },

  [NCSGridHeader.DonorAcceptanceBonus]: {
    title: "Hard to Place Donor Add Backs",
    description:
      "+1 TCE bonus applies to chain end waitlist transplants (excluding internal one ways) when the accepted donor meets at least one of the following criteria: donor age ≥ 65, left kidney with ≥ 3 arteries, right kidney with ≥ 2 arteries, creatinine clearance < 80 ml/min, or donor blood type AB. Real Time Swap Failure acceptances also qualify but are not required to meet these criteria.",
  },

  [NCSGridHeader.TargetedChainEnds]: {
    title: "Targeted Chain End",
    description:
      "Share of the Float + Net Chain Started Score + Hard to Place Donor Add Backs",
  },
};